import { Collapse, Container, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import Link from 'next/link';
import { nanoid } from 'nanoid';
import CustomAccordion from '../../shared/Custom-Accordion/CustomAccordion';
import SubDropdownMenu from './SubDropdownMenu';
import { useStyles } from '../style';

/**
 * @name DropdownMenuMobile
 * @description Displays list of primary navs in mobile device
 * @param {object} root0  - destructured object
 * @param {boolean} root0.expand - Data from Strapi
 * @param {Function} root0.handleExpand - Function for expanding nav list
 * @param {string} root0.nav - Data from Strapi
 * @param {boolean} root0.leftNav - To determine left or right nav
 * @returns {JSX.Element}  ReactJs Element
 */
const DropdownMenuMobile = ({ nav, expand, leftNav, handleExpand }) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  return (
    <Container>
      <Collapse in={expand} sx={{ width: '100%', boxShadow: 'none' }}>
        {expand &&
          nav?.map(link => (
            <CustomAccordion
              title={link.title}
              key={nanoid(8)}
              description={<SubDropdownMenu nav={link} handleExpand={handleExpand} />}
            />
          ))}
        {expand &&
          leftNav?.Link?.map(child => (
            <Link
              key={nanoid(8)}
              underline='none'
              component='a'
              href={child?.link}
              passHref
              onClick={handleExpand}
            >
              <Typography variant='h5' sx={styles.subNavLinks}>
                {child?.title}
              </Typography>
            </Link>
          ))}
      </Collapse>
    </Container>
  );
};

DropdownMenuMobile.displayName = 'DropdownMenuMobile';
export default DropdownMenuMobile;
